import React, { Suspense } from 'react'

import { DetailPanelSkeleton } from '@/components'
import { StructureObjectDto as StructureObjectDtoOld } from '@/endpoints/models'
import { ViewDetailV2 } from '@/pages/User/pages/Home/pages/ViewDetailV2'

import { useFormHighlightsData } from '../../../hooks/useFormHighlightsData'
import { useDetailTabContext } from '../context/DetailTabContext'

const ApiCollection = React.lazy(() =>
	import('../../../pages/ApiCollection/ApiCollection').then((m) => ({
		default: m.ApiCollection,
	})),
)
const ApiNode = React.lazy(() =>
	import('../../../pages/ApiNode/ApiNode').then((m) => ({
		default: m.ApiNode,
	})),
)
const FolderDetail = React.lazy(() =>
	import('../../../pages/FolderDetail/FolderDetail').then((m) => ({
		default: m.FolderDetail,
	})),
)
const WorkflowFolderDetail = React.lazy(() =>
	import('../../../pages/WorkflowFolderDetail/WorkflowFolderDetail').then(
		(m) => ({
			default: m.WorkflowFolderDetail,
		}),
	),
)
const MappingDetail = React.lazy(() =>
	import('../../../pages/MappingDetail/MappingDetail').then((m) => ({
		default: m.MappingDetail,
	})),
)
const ReadMappingDetail = React.lazy(() =>
	import('../../../pages/ReadMappingDetail/ReadMappingDetail').then((m) => ({
		default: m.ReadMappingDetail,
	})),
)
const WriteMappingDetail = React.lazy(() =>
	import('../../../pages/WriteMappingDetail/WriteMappingDetail').then((m) => ({
		default: m.WriteMappingDetail,
	})),
)
const QueueDetail = React.lazy(() =>
	import('../../../pages/QueueDetail/QueueDetail').then((m) => ({
		default: m.QueueDetail,
	})),
)
const SystemDetail = React.lazy(() =>
	import('../../../pages/SystemDetail/SystemDetail').then((m) => ({
		default: m.SystemDetail,
	})),
)
const TableDetail = React.lazy(() =>
	import('../../../pages/TableDetail/TableDetail').then((m) => ({
		default: m.TableDetail,
	})),
)
const WorkflowDetail = React.lazy(() =>
	import('../../../pages/WorkflowDetail/WorkflowDetail').then((m) => ({
		default: m.WorkflowDetail,
	})),
)
const DiagramDetail = React.lazy(() =>
	import('../../../pages/DiagramDetail/DiagramDetail').then((m) => ({
		default: m.DiagramDetail,
	})),
)

const DetailFallback = () => <DetailPanelSkeleton />

export const DetailTabSwitcher = () => {
	const {
		state: { node },
	} = useDetailTabContext()

	useFormHighlightsData()

	const getTabDetail = () => {
		switch (node.type) {
			case StructureObjectDtoOld.TypeEnum.API_COLLECTION: {
				return <ApiCollection />
			}

			case StructureObjectDtoOld.TypeEnum.API_NODE: {
				return <ApiNode />
			}

			case StructureObjectDtoOld.TypeEnum.FOLDER: {
				return <FolderDetail />
			}

			case StructureObjectDtoOld.TypeEnum.FOLDER_WORKFLOW: {
				return <WorkflowFolderDetail />
			}

			case StructureObjectDtoOld.TypeEnum.MAPPING: {
				return <MappingDetail />
			}

			case StructureObjectDtoOld.TypeEnum.MAPPING_DEFAULT: {
				return <MappingDetail defaultMapping />
			}

			case StructureObjectDtoOld.TypeEnum.MAPPING_READ: {
				return <ReadMappingDetail />
			}

			case StructureObjectDtoOld.TypeEnum.MAPPING_WRITE: {
				return <WriteMappingDetail />
			}

			case StructureObjectDtoOld.TypeEnum.QUEUE: {
				return <QueueDetail />
			}

			case StructureObjectDtoOld.TypeEnum.SYSTEM: {
				return <SystemDetail />
			}

			case StructureObjectDtoOld.TypeEnum.TABLE: {
				return <TableDetail />
			}

			case StructureObjectDtoOld.TypeEnum.VIEW: {
				return <ViewDetailV2 />
			}

			case StructureObjectDtoOld.TypeEnum.WORKFLOW: {
				return <WorkflowDetail />
			}

			case 'DIAGRAM': {
				return <DiagramDetail />
			}
		}
	}

	return <Suspense fallback={<DetailFallback />}>{getTabDetail()}</Suspense>
}
